import { useTranslation } from 'react-i18next'

import { useMoneyFormat } from '@percent/workplace-giving/common/hooks'
import { useMatchedDonationCard } from './useMatchedDonationCard'
import { DashboardMetricCard } from '@percent/workplace-giving/common/components/DashboardMetricCard/DashboardMetricCard'

export function MatchedDonationCard(): JSX.Element | null {
  const { isLoading, matchDonation, partnerName } = useMatchedDonationCard()
  const { moneyFormat } = useMoneyFormat()
  const { t } = useTranslation()

  if (!isLoading && !((matchDonation?.amount ?? 0) > 0)) {
    return null
  }

  return (
    <DashboardMetricCard
      title={t('workplace_giving.totalDonated.matchedBy', { partnerName })}
      value={moneyFormat(matchDonation)}
      description={t('workplace_giving.common.thisFiscalYear')}
      isLoading={isLoading}
      icon="matched-funds"
      testId="matched-donation-card"
    />
  )
}
